export const FIRST_LOGIN_DAYS_TO_TRACK = [1, 2, 3, 4, 5, 7, 14, 28];